/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IncludeLeads/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function IncludeLeads({
  children,
  viewPath = "/App/Account/Search/Content/Filters/Content/IncludeLeads",
  onChange
  
}) {
let searchIncludeLeadsValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'include_leads',
})
let searchIncludeLeadsChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'include_leads',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 data="search.include_leads"
 value={searchIncludeLeadsValueData}
 onChange={searchIncludeLeadsChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Include leads"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}